import { Modal } from '@billy/design-system'
import { ReactElement, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { LegalMentionsType } from '../../../../../../enums/legalMentionsType'
import { useLegalMentionsModalForm } from '../../context/legalMentionsModalFormContext'
import { LegalMentionsModalBody } from './elements/LegalMentionsModalBody'
import { LegalMentionsModalFooter } from './elements/LegalMentionsModalFooter'

interface LegalMentionsModalComponentProps {
  modalId: string
}

export const LegalMentionsModalComponent = ({ modalId }: LegalMentionsModalComponentProps): ReactElement => {
  const { t } = useTranslation()
  const { variant } = useLegalMentionsModalForm()

  const legalMentionsModalHeaderTitle = useMemo((): Record<LegalMentionsType, string> => {
    return {
      [LegalMentionsType.EarlyPaymentDiscount]: t(
        'settings.organization.external_invoice.legal_mentions.modal.early_payment_discount.title',
      ),
      [LegalMentionsType.LatePaymentPenaltyRate]: t(
        'settings.organization.external_invoice.legal_mentions.modal.late_payment_penalty_rate.title',
      ),
    }
  }, [t])

  const modalTitle = legalMentionsModalHeaderTitle[variant]

  return (
    <>
      <Modal.Header title={modalTitle} closable id={modalId} />
      <LegalMentionsModalBody variant={variant} />
      <LegalMentionsModalFooter id={modalId} />
    </>
  )
}
